import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import { formatISO } from "date-fns";
import gtag from "ga-gtag";
import { useSnackbar } from "notistack";

import constants from "../../../assets/constants";
import * as AssessmentSession from "../../../state/redux/assessmentSession";
import * as PartnerSession from "../../../state/redux/partnerSession";
import * as PatientSession from "../../../state/redux/patientSession";
import * as UserSession from "../../../state/redux/userSession";
import { deepCopyObject } from "../../../utils/helpers";
import AlertDialog from "../../dialogs/alertDialog";
import AssessmentWizardDialog from "../../dialogs/assessmentWizardDialog";
import OmniUserInputDialog from "../../dialogs/omniUserInputDialog";
import UserDialog from "../../dialogs/userDialog";
import EmpireToDoListItem from "../../ui/empireToDoListItem";
import Widget from "../../ui/widget";
import WidgetList from "../../ui/widgetList";
import WidgetSkeleton from "../../ui/widgetSkeleton";
import WidgetTitle from "../../ui/widgetTitle";

const EmpireTodo = props => {
  const {
    userODM,
    organizationODM,
    userToDos,
    loadUserToDosRequest,
    updateUserToDosRequest,
    updateUserKPIRequest,
    userKPIs,
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const [showWelcomMessages] = useState(false);
  const [showUserDialog, setShowUserDialog] = useState(false);
  const [showAssessmentDialog, setShowAssessmentDialog] = useState(null);
  const [changedToDo, setChangedToDo] = useState(null);
  const [completeToDo, setCompleteToDo] = useState(null);
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const [updateKPI, setUpdateKPI] = useState(null);

  const [localToDos, setLocalToDos] = useState(null);

  const handleEditButtonClick = toDo => {
    setChangedToDo(toDo);
    if (toDo.toDoType === "takeAnotherAssessment") {
      setShowAssessmentDialog(true);
    } else if (toDo.toDoType === "profileCompletion") {
      setShowUserDialog(true);
    } else if (toDo.toDoType === "eosBusinessInformation") {
      setShowAssessmentDialog(constants.assessmentIDs.eosBusinessInformation);
    } else if (toDo.toDoType === "eos5Pillars") {
      setShowAssessmentDialog(constants.assessmentIDs.eos5Pillars);
    } else if (toDo.toDoType === "eosKPI") {
      // userKPIs;
      let theKPI = userKPIs.filter(kpi => kpi.omniData.name === toDo.kpiName);
      if (theKPI.length > 0) {
        setUpdateKPI(theKPI[0]);
      }
    }
    gtag("event", "partner_todo", {
      todo_type: toDo.toDoType,
    });
  };

  useEffect(() => {
    if (changedToDo && localToDos && completeToDo) {
      let myToDo = changedToDo;
      myToDo.isCompleted = true;
      myToDo.completeDate = formatISO(new Date());

      let letsChangeTheseToDos = deepCopyObject(localToDos);
      letsChangeTheseToDos[myToDo.key] = myToDo;
      setLocalToDos(letsChangeTheseToDos);
      updateUserToDosRequest(letsChangeTheseToDos);
      setChangedToDo(null);
      setCompleteToDo(false);
    }
  }, [localToDos, changedToDo, completeToDo, updateUserToDosRequest, setLocalToDos]);

  const handleDialogClose = buttonClicked => {
    setShowAlertDialog(false);

    if (buttonClicked === "ok") {
      setCompleteToDo(true);
    } else {
      setCompleteToDo(false);
    }
  };

  const [titleText, setTitleText] = useState("");
  const [title] = useState("Empire OS");

  useEffect(() => {
    if (showWelcomMessages) {
      setTimeout(() => {
        enqueueSnackbar("Thank you!", {
          variant: "success",
        });
      }, 2000);
    }
  }, [showWelcomMessages, enqueueSnackbar]);

  useEffect(() => {
    if (userToDos) {
      let length = userToDos.length;
      setTitleText(`${length} ${length === 1 ? "Reminder" : "Reminders"}`);
    }
  }, [userToDos]);

  useEffect(() => {
    if (userToDos == null && organizationODM != null && userODM != null) {
      //find!ak THIS IS REPLACED WHEN WE MOVE TODO TO THE DB/db
      loadUserToDosRequest();
    } else if (
      userToDos != null &&
      organizationODM != null &&
      userODM != null &&
      localToDos == null
    ) {
      setLocalToDos(userToDos);
    }
  }, [organizationODM, userODM, userToDos, localToDos, loadUserToDosRequest]);

  return (
    <Widget>
      <WidgetTitle title={title} text={titleText} loading={userODM == null}></WidgetTitle>

      {localToDos == null && <WidgetSkeleton />}
      {localToDos != null && (
        <WidgetList>
          {localToDos.map(toDo => {
            return (
              <EmpireToDoListItem
                key={toDo.key}
                toDoODM={toDo}
                onClickHandler={handleEditButtonClick}
              />
            );
          })}
        </WidgetList>
      )}
      {showUserDialog && (
        <UserDialog
          open={showUserDialog}
          tabId={1}
          omniODM={deepCopyObject(userODM)}
          onAccept={partner => {
            // Set the isVerified Flag
            partner.omniData.isVerified = true;
            //thats not what verified is for
            props.updatePartnerRequest(partner);

            setShowUserDialog(false);
            if (changedToDo) {
              setCompleteToDo(changedToDo);
            }
          }}
          onClose={() => {
            setShowUserDialog(false);
          }}
        />
      )}
      {showAlertDialog && (
        <AlertDialog
          dialogTitle="Change completion status"
          dialogMessage="Are you sure you want to mark this to do item as incomplete?"
          open={showAlertDialog}
          onAccept={() => {
            setShowAlertDialog(false);
            handleDialogClose("ok");
          }}
          onClose={() => {
            setShowAlertDialog(false);
            handleDialogClose("cancel");
          }}
        />
      )}
      {showAssessmentDialog != null && (
        <AssessmentWizardDialog
          open={showAssessmentDialog != null}
          lockAssessmentOmniType={showAssessmentDialog}
          autoStartAssessment={false}
          lockSubjectODM={userODM}
          onAccept={() => {
            if (changedToDo) {
              handleDialogClose("ok");
            }
            setShowAssessmentDialog(null);
          }}
          onClose={() => {
            if (changedToDo) {
              handleDialogClose("cancel");
              // completeToDo(changedToDo);
            }
            setShowAssessmentDialog(null);
          }}
        />
      )}
      {updateKPI && (
        <OmniUserInputDialog
          inputLabel={`Week ${updateKPI.omniData.values.length + 1} Value`}
          open={updateKPI}
          unitsLabel={updateKPI.omniData.postUnitLabel}
          dialogTitle={`${updateKPI.omniData.name}`}
          dialogMessage={`What is the latest ${updateKPI.omniData.name} KPI value?`}
          // dialogMessage={"Please enter the KPI value for this week"}
          onAccept={theValue => {
            try {
              let newODM = deepCopyObject(updateKPI);
              theValue = theValue.replace(/[^0-9]/g, "");
              updateKPI.kpiValue = theValue;

              newODM.omniData.values.push(updateKPI);
              updateUserKPIRequest(newODM);
            } catch (error) {
              console.log(error);
            }
            handleDialogClose("ok");
            setUpdateKPI(null);
          }}
          onClose={() => {
            handleDialogClose("cancel");
            setUpdateKPI(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  patientAssessments: state.patientSession.patientAssessments,
  partnerPatients: state.partnerSession.partnerPatients,
  partnerAssessments: state.partnerSession.partnerAssessments,
  partnerInvites: state.partnerSession.partnerInvites,
  userODM: state.userSession.userODM,
  userKPIs: state.userSession.userKPIs,
  organizationODM: state.userSession.organizationODM,
  userToDos: state.userSession.userToDos,
  awsUserGroup: state.userSession.awsGroup,
});

const mapDispatchToProps = {
  reflectUpdatedPatientODMRequest: PartnerSession.reflectUpdatedPatientODMRequest,

  updatePartnerRequest: PartnerSession.updatePartnerRequest,
  updatePatientRequest: PatientSession.updatePatientRequest,
  updateAssessmentRequest: AssessmentSession.updateAssessmentRequest,
  updateUserToDosRequest: UserSession.updateUserToDosRequest,
  loadUserToDosRequest: UserSession.loadUserToDosRequest,
  updateUserKPIRequest: UserSession.updateUserKPIRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmpireTodo);
